module.exports = __webpack_public_path__ + "static/media/agenticon.4d867bea.png";